import React, { useEffect, useState } from 'react'

// aws geo/api
import { createMap, drawPoints } from "maplibre-gl-js-amplify";
import { Geo, API } from 'aws-amplify'
import "maplibre-gl/dist/maplibre-gl.css";
// import { listSitesByOrganization } from '../../../managers/graphql/queries';

// redux
import { useAppSelector, useAppDispatch } from '../../hooks';

// mui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import InboxIcon from '@mui/icons-material/Inbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import RoomOutlinedIcon from '@mui/icons-material/RoomOutlined';
import { COLORS } from '../../theme/muiTheme';
import { Place } from 'aws-sdk/clients/location';
import { createOrganizationLocation } from '../../managers/redux/slices/locations';
import { Location } from '../../API';

interface CreateLocationProps {
    visible: boolean
    onClose: (newLocation: Location | null) => void,
    searchText: string | null
}

export default function CreateLocation(props: CreateLocationProps) {

    useEffect(() => {
        setVisible(props.visible)
    }, [props.visible])

    async function searchFromText() {
        setSelectedSearchResult(null)
        const results = await Geo.searchByText(searchText, {
            maxResults: 3,
            countries: ["USA"]
        })

        if (results) {
            setSearchResults(results)
        }
    }

    function handleClose(createdLocation: Location | null) {
        setVisible(false)
        setSearchText('')
        setSelectedSearchResult(null)
        setSearchResults(null)
        setSelectedLocationName(null)
        props.onClose(createdLocation)
    }

    const [visible, setVisible] = useState(false)
    const [searchText, setSearchText] = useState('')
    const [searchResults, setSearchResults] = useState<any>(null)
    const [selectedSearchResult, setSelectedSearchResult] = useState<null | Place>(null)
    const [selectedLocationName, setSelectedLocationName] = useState<null | string>(null)
    const [organizationSites, setOrganizationSites] = useState<null | any>(null)
    const [selectedOrganizationSite, setSelectedOrganizationSite] = useState<null | any>(null)
    const [loading, setLoading] = useState<boolean>(false)

    const authAccount = useAppSelector(state => state.authAccount)

    const dispatch = useAppDispatch()

    useEffect(() => {
        if (props.searchText) {
            setSearchText(props.searchText)
        }
    }, [props.searchText])

    async function _createLocation() {
        setLoading(true)
        const result = await dispatch(createOrganizationLocation({
            geoObject: selectedSearchResult,
            locationName: selectedLocationName
        }))
        if (result.payload.name == selectedLocationName) {
            handleClose(result.payload)
        }
        setLoading(false)
    }

    return (
        <div>
            <Dialog
                open={visible}
                // onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">
                    Create a location
                </DialogTitle>
                <DialogContent>
                    <Typography variant="h5" className="mt-3">Step 1 - Enter location address</Typography>
                    <TextField
                        id="searchForALocation"
                        variant="standard"
                        placeholder="Address, Location Name, Business Name"
                        inputProps={{ style: { fontSize: 16 } }}
                        fullWidth
                        value={searchText}
                        onChange={(e) => {
                            setSearchText(e.target.value)
                            setSearchResults(null)
                            setSelectedLocationName(null)
                        }}
                    />
                    <Typography variant="h5" className="mt-3">Step 2 - Search for entered address</Typography>
                    <Button onClick={() => searchFromText()} variant="outlined" style={{ width: '100%', marginTop: '20px' }}>Search</Button>

                    {
                        searchResults && <Typography variant="h5" className="mt-3">Step 3 - Select location</Typography>
                    }

                    {
                        searchResults && !selectedSearchResult ?
                            <List>
                                {
                                    searchResults.map((result: any) => {
                                        console.log(result)
                                        return (
                                            <ListItem disablePadding>
                                                <ListItemButton onClick={async () => {
                                                    setSelectedSearchResult(result)

                                                    const map = await createMap({
                                                        container: "searchMap", // An HTML Element or HTML element ID to render the map in https://maplibre.org/maplibre-gl-js-docs/api/map/
                                                        center: [result.geometry.point[0], result.geometry.point[1]],
                                                        zoom: 11,
                                                    })

                                                    map.on('load', function () {
                                                        drawPoints("userInputSource", // Arbitrary source name
                                                            [
                                                                {
                                                                    coordinates: [result.geometry.point[0], result.geometry.point[1]],
                                                                    title: 'Selected Location',
                                                                    address: result.label
                                                                },
                                                            ], // An array of coordinate data, an array of Feature data, or an array of [NamedLocations](https://github.com/aws-amplify/maplibre-gl-js-amplify/blob/main/src/types.ts#L8)
                                                            map,
                                                            {
                                                                showCluster: true,
                                                                unclusteredOptions: {
                                                                    showMarkerPopup: true,
                                                                },
                                                                clusterOptions: {
                                                                    showCount: true,
                                                                }
                                                            }
                                                        );
                                                    })
                                                }}>
                                                    <ListItemText primary={result.label} />
                                                </ListItemButton>
                                            </ListItem>
                                        )
                                    })
                                }
                            </List>
                            :
                            <div></div>
                    }

                    <div id="searchMap" style={{ height: selectedSearchResult ? '200px' : '0px', width: '100%', marginTop: '20px' }}></div>

                    {
                        selectedSearchResult && <Typography variant="h5" className="mt-3">Step 4 - Give the address a nickname</Typography>
                    }
                    {
                        selectedSearchResult ?
                            <TextField
                                id="locationName"
                                variant="standard"
                                placeholder="Give your location a name"
                                inputProps={{ style: { fontSize: 16 } }}
                                fullWidth
                                value={selectedLocationName}
                                style={{ marginTop: '20px' }}
                                onChange={(e) => {
                                    setSelectedLocationName(e.target.value)
                                }}
                            />
                            :
                            <div>
                            </div>
                    }
                </DialogContent>
                <DialogActions className="mt-3">
                    <Button disabled={loading} onClick={() => handleClose(null)}>Cancel</Button>
                    <Button 
                    disabled={selectedSearchResult == null || selectedLocationName == null || selectedLocationName == '' || loading ? true : false}
                    onClick={() => {
                        if (selectedSearchResult) {
                            setSelectedSearchResult(null)
                            setSelectedLocationName(null)

                            _createLocation()
                        }
                    }} variant="contained" autoFocus>
                        Add Location
                    </Button>
                </DialogActions>
            </Dialog>
            <div id="map"></div>
        </div>
    )
}